import { cloneElement } from 'react';

import { ReactComponent as ChevronDownIcon } from 'assets/icons/chevron-down.svg';
import { ReactComponent as ChevronLeftIcon } from 'assets/icons/chevron-left.svg';
import { ReactComponent as ChevronRightIcon } from 'assets/icons/chevron-right.svg';
import { ReactComponent as ChevronUpIcon } from 'assets/icons/chevron-up.svg';

import { ReactComponent as BellIcon } from 'assets/icons/bell.svg';
import { ReactComponent as CalendarIcon } from 'assets/icons/calendar.svg';
import { ReactComponent as CameraIcon } from 'assets/icons/camera.svg';
import { ReactComponent as CheckCircleIcon } from 'assets/icons/check-circle.svg';
import { ReactComponent as ClockIcon } from 'assets/icons/clock.svg';
import { ReactComponent as CrossIcon } from 'assets/icons/cross.svg';
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg';
import { ReactComponent as EyeClosed } from 'assets/icons/eye-closed.svg';
import { ReactComponent as EyeOpen } from 'assets/icons/eye-open.svg';
import { ReactComponent as LogoIcon } from 'assets/icons/logo.svg';
import { ReactComponent as OpenBookIcon } from 'assets/icons/open-book.svg';
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import { ReactComponent as SubLogoIcon } from 'assets/icons/sub-logo.svg';
import { ReactComponent as UserIcon } from 'assets/icons/user.svg';
import { ReactComponent as WarningCircleIcon } from 'assets/icons/warning-circle.svg';

const getIcon = (iconName: string) => {
  switch (iconName) {
    case 'bell':
      return <BellIcon />;

    case 'calendar':
      return <CalendarIcon />;

    case 'camera':
      return <CameraIcon />;

    case 'check-circle':
      return <CheckCircleIcon />;

    case 'clock':
      return <ClockIcon />;

    case 'cross':
      return <CrossIcon />;

    case 'chevron-up':
      return <ChevronUpIcon />;

    case 'chevron-down':
      return <ChevronDownIcon />;

    case 'chevron-left':
      return <ChevronLeftIcon />;

    case 'chevron-right':
      return <ChevronRightIcon />;

    case 'edit':
      return <EditIcon />;

    case 'eye-open':
      return <EyeOpen />;

    case 'eye-closed':
      return <EyeClosed />;

    case 'logo':
      return <LogoIcon />;

    case 'open-book':
      return <OpenBookIcon />;

    case 'plus':
      return <PlusIcon />;

    case 'sub-logo':
      return <SubLogoIcon />;

    case 'user':
      return <UserIcon />;

    case 'warning-circle':
      return <WarningCircleIcon />;

    default:
      return <BellIcon />;
  }
};

interface IconProps {
  icon: string;
  className?: string;
  onClick?: () => void;
}

export const Icon = (props: IconProps) => {
  return cloneElement(getIcon(props.icon), {
    onClick: props.onClick,
    className: props.className || `${props.icon}-icon`,
  });
};
